import React from "react";

import * as Styles from "./styles";

interface Props {
  text: string;
  value: number;
  valueSelected: number;
  onValueSelected: (val: number) => void;
}

const ComboBoxCommon: React.FC<Props> = (props) => {
  const isSelected = props?.value === props?.valueSelected;
  return (
    <Styles.Container onClick={() => props?.onValueSelected(props?.value)}>
      <Styles.Circle isSelected={isSelected}>
        {isSelected ? <Styles.InnerCircle isSelected={isSelected} /> : null}
      </Styles.Circle>
      <Styles.Text>{props?.text}</Styles.Text>
    </Styles.Container>
  );
};

export default ComboBoxCommon;
